import buildDataProvider from "./buildDataProvider";
import { useEffect, useState } from "react";
var useDataProvider = function (options) {
    var _a = useState(), dataProvider = _a[0], setDataProvider = _a[1];
    useEffect(function () {
        buildDataProvider(options).then(function (p) {
            setDataProvider(function () { return p; });
        });
    }, []);
    return dataProvider;
};
export default useDataProvider;
//# sourceMappingURL=useDataProvider.js.map